module.exports = __webpack_public_path__ + "static/media/181IT144.200e4748.jpg";